import i18next from 'i18next'
import { loadingAsyncState } from 'widgets-for-react'
import { SearchTab, searchTabs } from './searchState'
import { TopFilters, filteredUrl } from '../filters/filtersUtils'

export async function getSearchResults(
  searchTab: SearchTab,
  term?: string,
  pageSize?: number,
  page?: number
): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')

  const url = filteredUrl(`/api/v1/${searchTab}/search`)({
    term: term,
    page: page,
    pageSize: pageSize,
    language: i18next.language,
  })

  const response = await fetch(url,
    {
      method: 'get',
      headers: headers,
    }
  )
  if (!response.ok) throw Error(response.statusText)
  return await response.json()
}

export async function getComponentSearchResults(
  term?: string,
  pageSize?: number,
  topFilters?: TopFilters,
  page?: number
): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')

  const url = filteredUrl('/api/v1/components/search')({
    term: term,
    topFilters: topFilters,
    page: page,
    pageSize: pageSize,
    language: i18next.language,
  })

  const response = await fetch(url,
    {
      method: 'get',
      headers: headers,
    }
  )
  if (!response.ok) throw Error(response.statusText)
  return await response.json()
}

export async function getSearchCount(
  searchTab: SearchTab,
  term?: string
): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')

  const url = filteredUrl(`/api/v1/${searchTab}/search/count`)({
    term: term,
    language: i18next.language,
  })

  const response = await fetch(url,
    {
      method: 'get',
      headers: headers,
    }
  )
  if (!response.ok) throw Error(response.statusText)
  return await response.json()
}

export async function getComponentSearchCount(
  term?: string,
  topFilters?: TopFilters
): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')

  const url = filteredUrl(`/api/v1/components/search/count`)({
    term: term,
    topFilters: topFilters,
    language: i18next.language,
  })

  const response = await fetch(url,
    {
      method: 'get',
      headers: headers,
    }
  )
  if (!response.ok) throw Error(response.statusText)
  return await response.json()
}

export const loadSearchCount = (searchTab: SearchTab, term?: string, topFilters?: TopFilters) =>
  loadingAsyncState<number>(() => {
    const res = searchTab === 'components' ? getComponentSearchCount(term, topFilters) : getSearchCount(searchTab, term);
    return res.then((raw) =>
      typeof raw == 'number'
        ? {
            kind: 'result',
            value: raw,
            status: 200,
          }
        : {
            kind: 'failed',
            status: 404,
          }
    );
  })
